// ============= Imports =============
import React from 'react';
import {
  Container,
  ErrorText,
  Pill,
  PillRow,
  Title,
} from './styles';
import type { VisualPromptMultiSelectStepProps } from './types';

// ============= Component =============
export const VisualPromptMultiSelectStep: React.FC<
  VisualPromptMultiSelectStepProps
> = ({ step, answers, onAnswer, error }) => {
  const selected = (answers[step.mapsTo] as string[] | undefined) ?? [];

  const toggle = (label: string) => {
    const next = selected.includes(label)
      ? selected.filter((l) => l !== label)
      : [...selected, label];
    onAnswer(step.mapsTo, next);
  };

  return (
    <Container>
      <Title>{step.title}</Title>
      <PillRow>
        {step.options.map((opt) => (
          <Pill
            key={opt.id}
            type="button"
            $active={selected.includes(opt.label)}
            onClick={() => toggle(opt.label)}
          >
            {opt.label}
          </Pill>
        ))}
      </PillRow>
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};
